define('viewModels/privileged/composer/vmUtils',[
    'lib/knockout',
    'lib/lodash4',
    'util/keyCode'
], function (ko, _, KEY) {
    "use strict";

    // VmUtils module to be returned
    var mod = {};

    /**
     *    Creates a computed that maintains a list of subviews, of type SubViewConstructor
              and provides a function for removing subviews from the list
     *    viewModel - the viewModel to attach the computed to
     *    modelList - the observable containing the list of models to make viewmodels for
     *    SubViewConstructor - the constructor for the subviews; passed the model as its argument
     *    Additional parameters are passed as arguments to the subview constructor
     */
    mod.subviewList = function (viewModel, modelList, SubViewConstructor) {
        //Object to contain subviews, referenced by key
        var subViews = {};

        var subViewArguments = [].slice.call(arguments, 3);

        var computed = viewModel.computed(function vmUtils_subViewList_computed() {
            return _.map(modelList(), function vmUtils_subViewList_computed_map(model) {
                var id = _.isString(model) ? model : model.modelId;
                //Retrieve previously created subview if exists
                if(id in subViews) {
                    return subViews[id];
                }
                //else create a new one and store it
                //var subView = viewModel.subView(SubViewConstructor, model);
                var args = [SubViewConstructor, model].concat(subViewArguments);
                var subView = viewModel.subView.apply(this, args);
                subViews[id] = subView;
                return subView;
            });
        });

        computed.removeById = function (modelId) {
            var subView = subViews[modelId];
            delete subViews[modelId];
            return subView;
        };

        computed.getById = function (modelId) {
            return subViews[modelId];
        };

        return computed;
    };

    /*
     * A event handler used for keyDown events that prevents the enter key from being pressed, in order to avoid line breaks in contenteditables
     */
    mod.preventEnterKey = function(viewModel, event) {
        if (event.keyCode === KEY.ENTER) {
            event.preventDefault();
            return false;
        }

        return true;
    };

    /**
     *    Returns a computed that returns a list of validation errors; with nulls filtered out
     *        Seems to be a ko.validation bug; see:
                - http://stackoverflow.com/questions/13377399/first-item-in-errors-is-null
                - https://github.com/Knockout-Contrib/Knockout-Validation/issues/218 (possibly the root cause)
     *
     *    viewModel  - the viewModel to attach the computed to;
     *    modelProperty - the model observable with attached validation rules
     */
    mod.modelErrors = function (viewModel, modelProperty) {
        //This wrapping is needed to prevent ko.validation.group from adding properties to modelProperty
        var wrappedObj = {prop: modelProperty};
        var errors = ko.validation.group(wrappedObj);
        return viewModel.computed(function () {
            return _.filter(errors(), function(err) {
                return err !== null;
            });
        });
    };

    return mod;
});
